import React from 'react'
import { I18n } from 'react-redux-i18n'

import './style.scss'
import { getStaticImage } from 'utils/statics'
import { getFormatedDate } from 'utils'
import Attachment from '../../Attachment'

/**
 * Preview message reply in composer
 * @param {object} props
 * @param {object} props.onRemove
 * @param {string} props.inReplyTo
 * @param {object} props.replyInfo
 * @param {string} [props.replyInfo.text]
 * @param {[object]} [props.replyInfo.attachments]
 * @param {[object]} [props.replyInfo.buttons]
 * @param {string} [props.replyInfo.date]
 */
const ComposerPreviewReply = (props) => {
  const { replyInfo, inReplyTo, onRemove } = props

  if (!inReplyTo) return null
  if (!replyInfo) return null
  if (!replyInfo.text && !replyInfo.attachments?.length) return null

  return (
    <div
      className='composer-preview-reply'
    >
      <div
        className='composer-preview-reply__container'
      >
        <div
          className='composer-preview-reply__header'
        >
          <div
            className='composer-preview-reply__header__rigth'
          >
            <div
              className="composer-preview-reply__header__icon">
              <img
                src={getStaticImage('/icons/orange-brand/icon-arrow-uturn-right.svg')}
                alt={I18n.t('composer_preview_reply_to')}
              />
            </div>
            <div
              className='composer-preview-reply__header__title'
            >
              {I18n.t('composer_preview_reply_to')}
            </div>
          </div>
          {
            onRemove ? (
              <div
                className='composer-preview-reply__remove'
                onClick={onRemove}
              >
                <i className='fa fa-times' />
              </div>
            ) : null
          }
        </div>
        <div
          className='composer-preview-reply__body'
        >
          <div
            className='composer-preview-reply__body__container'
          >
            <div
              className='composer-preview-reply__body__text'
            >
              {replyInfo.text || ''}
            </div>
          </div>
          {
            replyInfo.date ? (
              <div
                className='composer-preview-reply__date'
              >
                {getFormatedDate({ isoString: replyInfo.date, withTime: true, withYear: true })}
              </div>
            ) : null
          }
        </div>
      </div>
      {
        replyInfo.attachments?.length ? (
          <div
            className='composer-preview-reply__attachment'
          >
            {
              replyInfo.attachments.map((att, index) => (
                <Attachment
                  key={index}
                  hiddenDownload
                  id={`attachment-${index}`}
                  url={att.urlLong || att.url}
                  mimeType={att.mimeType}
                  mimeSubtype={att.mimeSubtype}
                  shortUrl={att.url || att.shortUrl}
                  thumb={att.thumb}
                  withVirus={att.withVirus}
                  flexDirection="row"
                />
              ))
            }
          </div>
        ) : null
      }
    </div>
  )
}

export default ComposerPreviewReply